import { Box } from "@mui/material";
import { PurpleLockIcon } from "@common/icons.tsx";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";

interface TableHeaderLockProps {
    tooltip: string;
}

function TableHeaderLock(props: TableHeaderLockProps) {
    return (
        <DotLegalTooltip text={props.tooltip}>
            <Box sx={{ display: "flex", marginTop: "-2px", "& svg": { height: 14, width: 14 } }}>{PurpleLockIcon}</Box>
        </DotLegalTooltip>
    );
}

export default TableHeaderLock;
